export const ConfigName = 'engangsregistreringar';
export const ModuleName = 'engangsregistreringar';
export const DisplayName = 'Inställningar/urval';
